import { Box, InputBase, useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import SearchIcon from "../../assets/SVG/searchIcon";

export default function SearchInput({ value, mb, mr, ...props }) {
  const [focus, setFocus] = useState();
  const md = useMediaQuery("(max-width:450px)");
  useEffect(() => {
    if (value) {
      setFocus(true);
    }
  }, [value]);
  return (
    <>
      <Box
        mb={mb || "0px"}
        mr={mr || ""}
        display="flex"
        alignItems="center"
        borderRadius={"10px"}
        width={md === true ? "100%" : focus ? "250px" : "200px"}
        height="40px"
        onClick={() => (value ? setFocus(true) : setFocus(!focus))}
        px="5px"
        gap="10px"
        // border='solid 1px #579bfc'
        sx={
          focus
            ? {
                transition: "0.3s all",
                border: "solid 1px var(--emr-primary)",
                "& svg": {
                  "& path": {
                    fill: "var(--emr-primary)",
                  },
                },
              }
            : {
                backgroundColor: "var(--emr-background-silver)",
                transition: "0.3s all",
                ":visited": {
                  bgcolor: "white",
                },
                ":hover": {
                  bgcolor: "#88929B",
                  "& svg": {
                    "& path": {
                      fill: "white",
                    },
                  },
                  "& input": {
                    "::placeholder": {
                      opacity: "1",
                      color: "white",
                    },
                  },
                },
              }
        }
      >
        <SearchIcon />
        {/* <Typography color="#787878">جستجو</Typography> */}
        <InputBase
          value={value}
          placeholder="جستجو"
          {...props}
          sx={{ width: "50%", fontFamily: "Vazirmatn" }}
        />
      </Box>
    </>
  );
}
